module.exports = __webpack_public_path__ + "static/img/110.84a0fb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/110.png
// module id = pJgk
// module chunks = 0